var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCounselors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 9a8.333 8.333 0 0116.666 0v2.5a3.335 3.335 0 01-2.584 3.249 3.335 3.335 0 01-3.249 2.584H8.167a.833.833 0 110-1.666H11.5c.693 0 1.287-.423 1.539-1.025a2.5 2.5 0 01-1.539-2.309V9A2.5 2.5 0 0114 6.5h.833c.122 0 .242.009.36.026a6.669 6.669 0 00-12.385 0c.117-.017.237-.026.359-.026H4A2.5 2.5 0 016.5 9v3.333a2.5 2.5 0 01-2.5 2.5A3.333 3.333 0 01.667 11.5V9zm1.666 2.5c0 .92.747 1.667 1.667 1.667.46 0 .833-.373.833-.834V9A.833.833 0 004 8.167h-.833A.833.833 0 002.333 9v2.5zM15.667 9a.833.833 0 00-.834-.833H14a.833.833 0 00-.833.833v3.333c0 .46.373.834.833.834.92 0 1.667-.746 1.667-1.667V9z",
    fill: "#515158"
  })));
}

export default SvgCounselors;